import { useNavigation } from "@react-navigation/native";
import React, { useEffect } from "react";
import { ScrollView } from "react-native";
import RadioForm from "react-native-simple-radio-button";
import { useDispatch, useSelector } from "react-redux";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import useCMSEvents from "@hooks/useCMSEvents";
import Toast from "@utils/toast";
import t from "@constants/localization";
import Button from "../../components/Button";
import { ORDER_FLOW_EVENTS } from "../../constants/analyticsEventsCT";
import { replaceRequest, returnRequest } from "../../services/api";
import { scale, verticalScale } from "../../utils/scale";
import Images from "../SupportTree/components/Form/Images";
import TextArea from "./EditText";
import Success from "./SuccessModal";

const PATH = "screens/OrderDetails/OrderSupport";

const OrderSupport = (props) => {
  const navigation = useNavigation();
  const [value, setValue] = React.useState(undefined);
  const [desc, setDesc] = React.useState(undefined);
  const [image, setImage] = React.useState([]);
  const { ReturnReasons, ReplaceReasons } = useSelector(
    (state) => state.configReducer,
  );
  const configReducer = useSelector((state) => state.configReducer);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const trackEvent = useCMSEvents("Explain in Brief");
  const { selectedOrder = null } = useSelector((s) => s.orders);
  const returnItem = () => {
    setLoading(true);
    const body = {
      reason: value,
      description: desc,
      orderId: selectedOrder,
      itemId: props.route.params.itemId,
      image,
      quantity: props.route.params.quantity,
    };
    returnRequest(body)
      .then(() => {
        trackEvent(ORDER_FLOW_EVENTS.RETURN_REQUESTED, {
          order_id: selectedOrder,
          sku_id: props.route.params.itemId,
          reason: value || desc,
        });
        setLoading(false);
        setShowSuccessModal(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (value !== undefined || (desc !== undefined && desc !== "")) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [desc]);

  const replaceItem = () => {
    setLoading(true);
    const body = {
      reason: value,
      description: desc,
      orderId: selectedOrder,
      itemId: props.route.params.itemId,
      image,
      quantity: props.route.params.quantity,
    };
    replaceRequest(body)
      .then(({ data }) => {
        setLoading(false);
        trackEvent(ORDER_FLOW_EVENTS.REPLACEMENT_REQUESTED, {
          order_id: selectedOrder,
          sku_id: props.route.params.itemId,
          reason: value || desc,
        });
        setShowSuccessModal(true);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    if (value || desc) {
      props.route.params.isFrom === "return" ? returnItem() : replaceItem();
    } else {
      Toast.showShortToast(t(`${PATH}/pleaseFillTheForm`));
    }
  };
  return (
    <>
      <HeaderWithBackAndTitle
        route={{ name: t(`${PATH}/explain`) }}
        headertitle={t(`${PATH}/explain`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        rightComponent={null}
      />
      <ScrollView
        contentContainerStyle={{
          flex: 1,
          backgroundColor: "white",
          paddingHorizontal: 15,
        }}
      >
        <RadioForm
          radio_props={
            props.route.params.isFrom == "return"
              ? ReturnReasons
              : ReplaceReasons
          }
          initial=""
          buttonColor="rgba(0, 0, 0, 0.99)"
          selectedButtonColor="#E40046"
          style={{ fontSize: scale(14), marginVertical: verticalScale(10) }}
          radioStyle={{ marginTop: 15 }}
          buttonSize={11}
          buttonOuterSize={22}
          animation={false}
          onPress={(value) => {
            setValue(value), setDisabled(false);
          }}
        />
        <TextArea
          value={desc}
          onSubmit={(text) => {
            setDesc(text);
          }}
          formItem={{
            label: t(`${PATH}/writeAboutIssue`),
          }}
        />
        <Images
          onSubmit={(url) => setImage(url)}
          formItem={{ label: t(`${PATH}/uploadPhoto`) }}
        />
        <Button
          btnText={t(`${PATH}/submit`)}
          buttonFontType="bold"
          disabled={disabled}
          fontSize={scale(20)}
          buttonWidth={scale(330)}
          isSubmitting={loading}
          onPress={onSubmit}
          height={scale(50)}
          borderRadius={10}
          textStyle={{ fontSize: scale(20) }}
          containerStyle={{
            alignSelf: "center",

            borderRadius: 10,
          }}
        />
      </ScrollView>
      <Success
        visible={showSuccessModal}
        text={
          props.route.params.isFrom == "return"
            ? t(`${PATH}/returnCnfmMsg`)
            : t(`${PATH}/replaceCnfmMsg`)
        }
      />
    </>
  );
};

export default OrderSupport;
